import { GLOBAL_COLORS_HOLSTER, applyCamoMarkup } from '../config/globalSettings';

// ==========================================
// LIGHT GROUPS — DISABLED FOR VR LAUNCH
// No lightbearing option in this builder. Retained (commented) so the
// groups can be restored if VR handsets get light-compatible shells later.
// ==========================================

/*
// For Nidhogg/OWB, TLR-1 maps to x300 group in the visualizer
export const LIGHTS_UNIVERSAL = [
  "tlr1", "tlr1_hlx", "tlr7", "tlr7_hlx",
  "x300u_a", "x300u_b",
  "inforce_apl", "inforce_apl_3", "inforce_wild1", "inforce_aplc_uni",
  "olight_pl_mini", "olight_pl_mini2", "olight_pl2", "olight_pl_pro",
  "sig_foxtrot1x", "sig_foxtrot2r",
  "surefire_xc1b", "surefire_xc1c", "surefire_xc3"
];

export const LIGHTS_GLOCK = [
  ...LIGHTS_UNIVERSAL.filter(id => id !== "inforce_aplc_uni"),
  "inforce_aplc_glock"
];

export const LIGHTS_SIG_MACRO = ["tlr7", "tlr7_hlx", "tlr7_sub_1913", "sig_foxtrot1x", "sig_foxtrot2r", "tlr6"];

// --- QUICK SHIP LIGHT GROUPS ---
const LIGHTS_QS_SIG_MACRO = ["tlr7", "tlr7_hlx", "tlr7_sub_1913"];
const LIGHTS_QS_SIG_X5 = ["tlr1", "tlr1_hlx", "tlr7", "tlr7_hlx", "inforce_wild1", "x300u_a", "x300u_b"];
*/


// ==========================================
// MAIN DATA EXPORT
// ==========================================
export const holsterData = {
  brands: [
    { id: "sig", name: "Sig Sauer" },
    { id: "ace", name: "ACE" },
    { id: "cz", name: "CZ" },
    { id: "shadow_systems", name: "Shadow Systems" },
    { id: "springfield", name: "Springfield Armory" },
    { id: "staccato", name: "Staccato" }
  ],

  guns: [
    // --- SIG SAUER ---
    { id: "sig_x5_legion_vr", brand_id: "sig", name: "SIG P320-XFIVE LEGION ACE VR", no_left_hand: false, qs_nlb_rh: true, qs_nlb_lh: true, lead_time: "5-7 Days" },
    { id: "sig_xmacro_comp_vr", brand_id: "sig", name: "SIG P365-XMACRO COMP ACE VR", no_left_hand: false, qs_nlb_rh: true, qs_nlb_lh: true, lead_time: "5-7 Days" },

    // --- ACE / GLOCK ---
    { id: "ace_17_vr", brand_id: "ace", name: "ACE 17 VR", no_left_hand: false, qs_nlb_rh: true, qs_nlb_lh: true, lead_time: "5-7 Days" },
    { id: "ace_19_vr", brand_id: "ace", name: "ACE 19 VR", no_left_hand: false, qs_nlb_rh: true, qs_nlb_lh: true, lead_time: "5-7 Days" },

    // --- CZ ---
    { id: "cz_shadow_2_vr", brand_id: "cz", name: "CZ Shadow 2 ACE VR", no_left_hand: false, qs_nlb_rh: true, qs_nlb_lh: true, lead_time: "5-7 Days" },

    // --- SHADOW SYSTEMS ---
    { id: "ss_mr920_vr", brand_id: "shadow_systems", name: "Shadow Systems MR920 ACE VR", no_left_hand: false, qs_nlb_rh: true, qs_nlb_lh: true, lead_time: "5-7 Days" },

    // --- SPRINGFIELD ARMORY ---
    { id: "springfield_trp_vr", brand_id: "springfield", name: "Springfield Armory 1911 TRP ACE VR", no_left_hand: false, qs_nlb_rh: true, qs_nlb_lh: true, lead_time: "5-7 Days" },

    // --- STACCATO ---
    { id: "staccato_p_vr", brand_id: "staccato", name: "Staccato P ACE VR", no_left_hand: false, qs_nlb_rh: true, qs_nlb_lh: true, lead_time: "5-7 Days" }
  ],

  /*
  // --- LIGHT OPTIONS — DISABLED ---
  lights: [
    ... (Disabled Light Options Omitted for brevity, retain your commented out block if needed)
  ],
  */

  // --- OPTIONS ---
  hands: [
    { id: "right", name: "Right Handed" },
    { id: "left", name: "Left Handed" }
  ],

  /*
  // --- LIGHTBEARING TOGGLE — DISABLED ---
  lightbearing_options: [
    { id: "no", name: "Non-Lightbearing" },
    { id: "yes", name: "Lightbearing" }
  ],
  */

  // --- COLORS (MAPPED FOR $20 MARKUP) ---
  colors: applyCamoMarkup(GLOBAL_COLORS_HOLSTER, 20),

  // --- MOUNTS ---
  mounts: [
    {
      id: "rti",
      name: "RTI Hanger",
      price: 14.00,
      img_layer_mount: "/images/mounts/rti_front.png",
      img_layer_mount_back: "/images/mounts/rti_back.png",
      description: "G-Code RTI Hanger for QD mounting."
    },
    {
      id: "qls_fork",
      name: "SAFARILAND QLS Fork",
      price: 17.99,
      img_layer_mount: "/images/mounts/qls_front.png",
      img_layer_mount_back: "/images/mounts/qls_back.png",
      description: "Quick Locking System fork only."
    },
    {
      id: "qls_kit",
      name: "SAFARILAND QLS/Q22 (Male & Female)",
      price: 39.99,
      img_layer_mount: "/images/mounts/qls_front.png",
      img_layer_mount_back: "/images/mounts/qls_back.png",
      description: "Complete Quick Locking System kit (Fork & Receiver Plate)."
    },
    {
      id: "tek_lok",
      name: "Blade-Tech Tek-Lok Mount",
      price: 12.50,
      img_layer_mount: "/images/mounts/teklok_front.png",
      img_layer_mount_back: "/images/mounts/teklok_back.png",
      description: "Secure, adjustable belt attachment system."
    },
    {
      id: "tac_belt_standard",
      name: "Tactical Belt Mount (Bolted Directly)",
      price: 0,
      description: "Bolted directly to the holster. Choose color and size below.",
      warning: "DESIGNED TO BE USED WITH OUR FULCRUM AND THIGHBAND OR EQUIVALENT THIGH BAND SYSTEM. If used as a standalone item, extreme outward torsion away from the body can result in cracks or breakages at the belt."
    },
    {
      id: "dropleg_qls",
      name: "Full Dropleg Setup with QLS",
      price: 39.99,
      description: "Complete setup including shroud, strap, and QLS system."
    },
    {
      id: "dropleg_no_qls",
      name: "Full Dropleg Setup (No QLS)",
      price: 0,
      description: "Complete setup bolted directly (No Quick Locking System)."
    },
    {
      id: "no_mount",
      name: "No Mount",
      price: 0,
      description: "Holster shell only, pre-drilled for standard mounting patterns."
    }
  ],

  // --- SUB-OPTIONS FOR TAC BELT ---
  tac_belt_colors: [
    { id: "black", name: "Black", price: 17.99 },
    { id: "coyote", name: "Coyote", price: 17.99 },
    { id: "od_green", name: "OD Green", price: 17.99 },
    { id: "multicam", name: "Multicam", price: 34.99 },
    { id: "multicam_black", name: "Multicam Black", price: 34.99 },
    { id: "multicam_tropic", name: "Multicam Tropic", price: 34.99 },
    { id: "multicam_arid", name: "Multicam Arid", price: 34.99 }
  ],

  tac_belt_sizes: [
    { id: "std_150", name: "Standard 1.50\"", price: 0 },
    { id: "std_175", name: "Standard 1.75\"", price: 0 },
    { id: "std_200", name: "Standard 2.0\"", price: 0 },
    { id: "short_150", name: "Short 1.50\"", price: 0 },
    { id: "short_175", name: "Short 1.75\"", price: 0 },
    { id: "short_200", name: "Short 2.0\"", price: 0 }
  ],

  // --- SUB-OPTIONS FOR DROPLEG ---
  fulcrum_colors: [
    { id: "black", name: "Black", price: 15.99 },
    { id: "carbon_fiber", name: "Carbon Fiber", price: 15.99 },
    { id: "coyote_carbon", name: "Coyote Tan Carbon Fiber", price: 15.99 }
  ],

  thigh_band_colors: [
    { id: "black", name: "Black", price: 16.99 },
    { id: "tan", name: "Tan", price: 16.99 }
  ],

  // --- ADD-ON MAG MOUNTS ---
  mag_mounts: [
    { id: "clip_15", name: "1.5\" Injection Molded Clip", price: 0 },
    { id: "clip_175", name: "1.75\" Injection Molded Clip", price: 0 },
    { id: "dcc_ANRlogo", name: "1.5\" DCC Monoblock ANR Logo", price: 4.99 },
    { id: "dcc_nologo", name: "1.5\" DCC Monoblock No Logo", price: 4.49 },
    { id: "dcc_FDElogo", name: "1.5\" DCC Monoblock FDE w/ Logo", price: 4.99 },
    { id: "dcc_TOPOlogo", name: "1.5\" DCC Monoblock Topographical", price: 5.49 },
    { id: "neomag", name: "Neomag Alias TPost", price: 15.99 },
    { id: "neomag_receiver", name: "Neomag Alias TPost and Neomag Alias Belt Receiver", price: 49.99 }
  ],

  // --- EXTENDED THUMB SCREWS ---
  thumb_screws: [
    { id: "no", name: "No Thanks", price: 0 },
    { id: "yes", name: "Add Extended Thumb Screws", price: 8.50 },
  ],

  // --- MAG CARRIERS ---
  mag_carriers: [
    { id: "no", name: "No Thanks", price: 0 },
    { id: "yes_1", name: "Yes Add 1", price: 29.99 },
    { id: "yes_2", name: "Yes Add 2", price: 49.99 },
    { id: "mystery", name: "1 Mystery Limited Edition Kydex Pattern", price: 29.99 }
  ],
};